const GRID_SELECTOR = "[data-shared-gradient-grid]";
const CARD_SELECTOR = "[data-shared-gradient-card]";

function syncSharedGradientGrid(grid) {
	const cards = Array.from(grid.querySelectorAll(CARD_SELECTOR));

	if (!cards.length) {
		return;
	}

	const gridRect = grid.getBoundingClientRect();

	grid.style.setProperty("--gradient-grid-width", `${gridRect.width}px`);
	grid.style.setProperty("--gradient-grid-height", `${gridRect.height}px`);

	for (const card of cards) {
		const cardRect = card.getBoundingClientRect();

		card.style.setProperty("--gradient-card-x", `${gridRect.left - cardRect.left}px`);
		card.style.setProperty("--gradient-card-y", `${gridRect.top - cardRect.top}px`);
	}
}

function initSharedGradientGrid(grid) {
	let frameId = null;

	const scheduleSync = () => {
		if (frameId) {
			return;
		}

		frameId = window.requestAnimationFrame(() => {
			frameId = null;
			syncSharedGradientGrid(grid);
		});
	};

	const resizeObserver = new ResizeObserver(scheduleSync);
	resizeObserver.observe(grid);

	for (const card of grid.querySelectorAll(CARD_SELECTOR)) {
		resizeObserver.observe(card);
	}

	window.addEventListener("resize", scheduleSync, { passive: true });
	window.addEventListener("load", scheduleSync, { once: true });
	scheduleSync();
}

export function initSharedGradientCards() {
	for (const grid of document.querySelectorAll(GRID_SELECTOR)) {
		initSharedGradientGrid(grid);
	}
}
